import { IconDesktop16Cross } from '@fabric-app/icons/svg';
import { Flex } from '@fabric-app/ui/components/Flex';
import Color from 'color';
import React from 'react';
import styled from 'styled-components';

export const ColorPill: React.FC<{ color: string; resetColor: () => void }> = ({
  color: colorHex,
  resetColor,
}) => {
  const style = React.useMemo(() => {
    try {
      const color = new Color(colorHex);
      return {
        backgroundColor: color.hex(),
        color: color.isDark() ? '#fff' : '#000',
      };
    } catch {
      return {
        backgroundColor: colorHex,
        color: '#fff',
      };
    }
  }, [colorHex]);

  return (
    <Container style={style}>
      <Flex alignItems="center" gap={'text'}>
        <span style={{ opacity: 0.5 }}>#</span>
        {colorHex ? colorHex.replace('#', '') : 'Unknown color'}
        <IconDesktop16Cross onClick={resetColor} />
      </Flex>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  padding: 0 0.5rem;
  gap: 8;
  font-size: 13px;
  font-weight: 500;
  border-radius: 8px;
  text-transform: uppercase;
  svg {
    cursor: pointer;
  }
`;
